import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const StyledDialog = styled.div`
	.custom-dialog {
		width: 100%;
		${breakPoints({
			'768': `
				width: 750px;
			`,
		})}
	}
`;

export const StyledCarInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const StyledCarImage = styled.div`
	align-self: center;
	${breakPoints({
		'768': `
			max-width: 390px;
		`,
	})}

	img {
		aspect-ratio: 16 / 9;
		width: 100%;
		flex-shrink: 0;
		object-fit: cover;
	}
`;

export const StyledButtonContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-bottom: 20px;
	${breakPoints({
		'768': `
			max-width: 550px;
			width: 100%;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
		`,
	})}
`;

export const StyledImage = styled.img`
	max-width: 100%;
	height: auto;
	margin-top: 10px;
	margin-bottom: 10px;

	${breakPoints({
		'768': `
			max-width: 450px;
		`,
	})}
`;

export const StyledList = styled.ul`
	margin: 5px 0 25px;
	list-style-type: disc;
	padding-left: 20px;
	display: flex;
	flex-direction: column;
	& > li::marker {
		color: #fff;
	}
`;
